import { render, staticRenderFns } from "./EmailComposer.vue?vue&type=template&id=02ddbb55&"
import script from "./EmailComposer.vue?vue&type=script&lang=js&"
export * from "./EmailComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports